export enum Currency {
  NOK = 'NOK',
  EUR = 'EUR',
  SEK = 'SEK',
}

export enum Country {
  NORWAY = 'NORWAY',
  GERMANY = 'GERMANY',
  SWEDEN = 'SWEDEN',
}

export function getCurrencyForLocation(location: string): Currency {
  switch (location) {
    case Country.NORWAY:
      return Currency.NOK;
    case Country.GERMANY:
      return Currency.EUR;
    default:
      return Currency.SEK;
  }
}
